var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_5904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4346 22.8559H23.1986L22.7606 22.4335C24.2938 20.6501 25.2168 18.3347 25.2168 15.8159C25.2168 10.1995 20.6642 5.64697 15.0478 5.64697C9.43146 5.64697 4.87891 10.1995 4.87891 15.8159C4.87891 21.4323 9.43146 25.9848 15.0478 25.9848C17.5666 25.9848 19.882 25.0618 21.6655 23.5287L22.0879 23.9667V25.2026L29.9101 33.0092L32.2412 30.6782L24.4346 22.8559ZM15.0478 22.8559C11.1524 22.8559 8.00781 19.7114 8.00781 15.8159C8.00781 11.9204 11.1524 8.77588 15.0478 8.77588C18.9433 8.77588 22.0879 11.9204 22.0879 15.8159C22.0879 19.7114 18.9433 22.8559 15.0478 22.8559Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_5904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5468,
    height: 37.5468,
    fill: "white",
    transform: "translate(0.1875 0.953125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.00e3d1ef702ebdfea95716f01eee9aac.svg";
export { ForwardRef as ReactComponent };